import blackdata from '../static/img/blackdata.png'
import lesmills from '../static/img/lesmills_chile.png'
import fitplaza from '../static/img/fitplaza.png'

const Experience = () => {
    return (
        <section
            id="experience"
            data-nav-tooltip="Experience"
            className="pp-section pp-scrollable section counter">

            <div className="container">
                <div className="title">
                    <h3>Experiencia.</h3>
                </div>
                <div className="row align-items-center justify-content-center">

                    <div className="about-info">
                        <div className="resume-box">
                            <div className="resume-row">
                                <div className="row">
                                    <div className="col-sm-3 col-md-3 col-xl-2">
                                        <div className="rb-left">
                                            <img src={blackdata} style={{ borderRadius: '150px' }} width='70%' title="" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-sm-9 col-md-9 col-xl-10">
                                        <div className="rb-right">
                                            <h6>Desarrollador FullStack</h6>
                                            <label>Black Data | Presencial | Junio 2023 a la fecha</label>
                                            <div className="rb-time">Full Time</div>
                                            
                                                <p>Como Desarrollador Fullstack, me especialicé en contribuir al ciclo completo de desarrollo, mantenimiento y soporte de plataformas y módulos para satisfacer las necesidades de los clientes. Mis responsabilidades clave incluyeron la creación y gestión integral de módulos, destacando mi enfoque en el aprendizaje continuo. Trabajé de manera eficaz tanto de forma individual como en colaboración con el equipo, con el objetivo principal de garantizar el correcto funcionamiento y eficiencia de los módulos desarrollados. Además, mi participación activa se centró en mejorar procesos y crear un ambiente propicio para el aprendizaje y desarrollo.
                                                </p>
   
                                            <p className='m-2'><strong>Tecnologías</strong></p>
                                            <ul>
                                                <li> <b>Codeigniter, PHP, JavaScript, HTML, CSS, MySql, Git, GitHub.</b></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="resume-row">
                                <div className="row">
                                    <div className="col-sm-3 col-md-3 col-xl-2">
                                        <div className="rb-left">
                                            <img src={lesmills}  style={{ borderRadius: '100px' }} width='70%' title="" alt="" />
                                        </div>
                                        
                                    </div>
                                    
                                    <div className="col-sm-9 col-md-9 col-xl-10">
                                        <div className="rb-right">
                                            <h6>Desarrollador FullStack, Soporte de App "Releases" y Contenido Digital</h6>
                                            <label>Les Mills Chile | Remote y Presencial | Marzo 2022 a la fecha</label>
                                            <div className="rb-time">Full Time</div>
                                            <p>Como Desarrollador Fullstack, mi enfoque se centró en contribuir al mantenimiento y soporte de plataforma <a href='https://www.lesmills.cl' target='_blank' rel='noreferrer'>www.lesmills.cl</a>.
                                            <br></br>
                                                En mi rol, desempeño un papel crucial en la gestión proactiva del mantenimiento necesario para garantizar el correcto funcionamiento de la plataforma. Asimismo, asumí la responsabilidad de resolver problemas relacionados con la aplicación "Releases" de Les Mills, desde la activación de kits digitales para instructores actualizados hasta la revisión de licencias y su acceso a los servicios. Mi contribución activa también se mantiene en la creación de gráficas informativas sobre proximos módulos, para atraer a nuevos instructores. Como parte integral de mi función, continúo gestionando las redes sociales de Les Mills Chile, asegurando una presencia sólida y coherente en línea.
                                            </p>
                                                <br/>
                                            <p className='m-2'><strong>Tecnologías</strong></p>
                                            <ul>
                                                <li> <b>HTML, CSS, JavaScript, TypeScript, Angular, MySql, PHP, Laravel, Git, GitHub, Photoshop.</b></li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="resume-row">
                                <div className="row">
                                    <div className="col-sm-3 col-md-3 col-xl-2">
                                        <div className="rb-left">
                                            <img src={lesmills} style={{ borderRadius: '150px' }} width='70%' title="" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-sm-9 col-md-9 col-xl-10">
                                        <div className="rb-right">
                                            <h6>Tribe Coach, Consultor y Presentador Nacional</h6>
                                            <label>Les Mills | Remoto y Presencial | Diciembre 2018 a la fecha</label>
                                            <div className="rb-time">Full Time</div>
                                            <p>
                                            Desde 2018, como Tribe Coach en Les Mills Chile, colaboré con entrenadores, brindé apoyo en módulos presenciales y motivé a instructores en sus primeros pasos en fitness grupal. Además, como consultor, evalué instructores en proceso de certificación, ofreciendo apoyo y orientación para cumplir con estándares de calidad. Como Presentador Nacional, participé en eventos clave, presentando nuevas coreografías y material educativo. Mi misión es impulsar el crecimiento y la excelencia en Les Mills Chile, fusionando mi experiencia para fortalecer la comunidad fitness nacional.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="resume-row">
                                <div className="row">
                                    <div className="col-sm-3 col-md-3 col-xl-2">
                                        <div className="rb-left">
                                            <img src={fitplaza} style={{ borderRadius: '150px' }} width='70%' title="" alt="" />
                                        </div>
                                    </div>
                                    <div className="col-sm-9 col-md-9 col-xl-10">
                                        <div className="rb-right">
                                            <h6>Instructor de Fitness Grupal y Entrenador Personal</h6>
                                            <label>Gimnasio FitPlaza | Presencial | Diciembre 2022 a la fecha</label>
                                            <div className="rb-time">Part Time</div>
                                            <p>Con más de 10 años como instructor de fitness grupal y entrenador personal, destaco por mi experiencia en planificar, guiar y corregir entrenamientos para ayudar a los clientes a alcanzar sus objetivos físicos propuestos. Especializado en clases de BodyCombat, mantengo los más altos estándares establecidos por Les Mills Internacional al poseer todas las certificaciones del programa.</p>
                                            
                                        </div>
                                    </div>
                                </div>
                                
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <div className="separated" />

        </section>
    )
}

export default Experience;